export enum AprContainerKey {
  RECOMMENDED_FOR_YOU = 'product-1',
  YOUR_FAVORITES = 'product-2',
}

export enum Channel {
  DESKTOP = 'desktop',
}
